// hooks/useUserWorkspace.js
import { useState, useCallback, useRef } from "react";
import {
  fetchWorkspaceRoleApi,
  fetchWorkspacesByUserIdApi,
} from "../service/api";

export const useUserWorkspace = (userId, defaultWorkspaceId, apiUrl) => {
  const [defaultWorkspaceRole, setDefaultWorkspaceRole] = useState(null);
  const [loadingWorkspaceRole, setLoadingWorkspaceRole] = useState(false);
  const [userWorkspace, setUserWorkspace] = useState();
  const [role, setRole] = useState(null);
  const [isRoleLoading, setIsRoleLoading] = useState(false);

  // Guards against duplicate in-flight requests (e.g. StrictMode double-invoked
  // mount effects) so the same endpoint isn't called twice concurrently.
  const roleInFlightRef = useRef(false);
  const workspacesInFlightRef = useRef(false);

  const fetchWorkspaceRole = useCallback(async () => {
    if (!userId || !defaultWorkspaceId) {
      setDefaultWorkspaceRole(null);
      return;
    }
    if (roleInFlightRef.current) return;
    roleInFlightRef.current = true;
    setLoadingWorkspaceRole(true);
    try {
      const role = await fetchWorkspaceRoleApi(
        userId,
        defaultWorkspaceId,
        apiUrl,
      );
      setDefaultWorkspaceRole(role);
    } catch (error) {
      console.error("Error fetching workspace role:", error);
      setDefaultWorkspaceRole(null);
    } finally {
      setLoadingWorkspaceRole(false);
      roleInFlightRef.current = false;
    }
  }, [apiUrl, userId, defaultWorkspaceId]);

  const fetchUserWorkspaces = useCallback(async () => {
    if (workspacesInFlightRef.current) return;
    workspacesInFlightRef.current = true;
    try {
      const workspacesData = await fetchWorkspacesByUserIdApi(userId, apiUrl);
      setUserWorkspace(workspacesData);
    } catch (error) {
      console.error("Error fetching workspaces:", error);
      setRole(null);
    } finally {
      setIsRoleLoading(false);
      workspacesInFlightRef.current = false;
    }
  }, [apiUrl, userId]);

  return {
    defaultWorkspaceRole,
    loadingWorkspaceRole,
    userWorkspace,
    role,
    isRoleLoading,
    fetchWorkspaceRole,
    fetchUserWorkspaces,
  };
};
